module.exports = __webpack_public_path__ + "img/黄思静.8a32b6a4.jpg";